import { useSeo } from "../lib/useSeo";
import { ArrowUpRight } from "lucide-react";
import { LINKS, CATEGORIES } from "../lib/constants";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PageHero, Label, ProductGrid } from "../components/bits";
import { ASSETS } from "../lib/constants";

export default function Shop() {
  useSeo("/shop");
  return (
    <div data-testid="shop-page">
      <PageHero
        label="Premium Selection"
        title="Shop Higher Ground DC"
        subtitle="Browse our curated selection of premium cannabis products. Featured products sync from our live Flowhub menu, so the selection rotates as inventory changes."
        image={ASSETS.brandedBags}
        testid="shop-hero"
      />

      {/* Live menu banner */}
      <section className="border-y border-white/10 bg-ink-2">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-4 px-6 py-6 md:flex-row md:items-center lg:px-12">
          <p className="flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-white/60">
            <span className="h-2 w-2 animate-pulse rounded-full bg-gold" /> Live menu · refreshed throughout the day
          </p>
          <a href={LINKS.menu} target="_blank" rel="noopener noreferrer" data-testid="shop-fullmenu-top" className="inline-flex items-center gap-2 bg-gold px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-ink transition-colors hover:bg-champagne">
            Browse Full Menu <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>

      {/* Categories */}
      <section className="bg-ink py-20 md:py-28" data-testid="shop-categories">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <Reveal><Label>Shop by Category</Label></Reveal>
          <Stagger className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
            {CATEGORIES.map((c) => (
              <StaggerItem key={c.name}>
                <a href={c.url} target="_blank" rel="noopener noreferrer" data-testid={`category-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="group flex h-28 flex-col items-center justify-center border border-white/10 bg-ink-2 p-4 text-center transition-all duration-400 hover:border-gold/60 hover:bg-ink-3">
                  <span className="text-sm uppercase tracking-[0.12em] text-white transition-colors group-hover:text-gold">{c.name}</span>
                  <ArrowUpRight className="mt-2 h-4 w-4 text-white/30 transition-colors group-hover:text-gold" />
                </a>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* Best sellers */}
      <section className="border-t border-white/10 bg-ink-2 py-20 md:py-28" data-testid="shop-bestsellers">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
          <div className="flex items-end justify-between">
            <div>
              <Reveal><Label>Best Sellers</Label></Reveal>
              <Reveal delay={0.1}><h2 className="mt-4 font-display text-3xl font-light uppercase tracking-[0.08em] text-white md:text-4xl">Menu Favorites</h2></Reveal>
            </div>
            <Reveal delay={0.15}>
              <a href={LINKS.menu} target="_blank" rel="noopener noreferrer" data-testid="shop-viewall" className="hidden items-center gap-2 text-xs uppercase tracking-[0.22em] text-gold hover:text-champagne md:inline-flex">View All <ArrowUpRight className="h-4 w-4" /></a>
            </Reveal>
          </div>

          <div className="mt-12">
            <ProductGrid testPrefix="shop-product" />
          </div>

          <Reveal delay={0.1}>
            <div className="mt-14 flex flex-col items-center gap-6 border border-white/10 bg-ink p-10 text-center md:p-16">
              <h3 className="font-display text-2xl font-light uppercase tracking-[0.1em] text-white md:text-3xl">The Full Menu Lives on Flowhub</h3>
              <p className="max-w-2xl text-white/55">Real-time inventory, potency, pricing and product details — all refreshed live throughout the day.</p>
              <a href={LINKS.menu} target="_blank" rel="noopener noreferrer" data-testid="shop-fullmenu-bottom" className="inline-flex items-center gap-2 bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.22em] text-ink transition-colors hover:bg-champagne">
                Browse Full Menu <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
